import { type ReactNode } from 'react'
import { useDeviceDetection } from '../hooks/useDeviceDetection'
import { DeviceRestrictionMessage } from './DeviceRestrictionMessage'

interface DeviceGuardProps {
  children: ReactNode
}

export const DeviceGuard = ({ children }: DeviceGuardProps) => {
  const { shouldRestrict } = useDeviceDetection()

  if (shouldRestrict) {
    return <DeviceRestrictionMessage />
  }

  return <>{children}</>
}